import { Livewire } from '@shared/livewire.js'
import '@shared/forms/stripe.js'
import '@shared/forms/paypal.js'

Livewire.start()
